import { queryOptions } from '@tanstack/react-query';

import { zoningApi } from '../apis/zoning-api';
import { applyPendingMeasureUpdates } from '../hooks/use-update-measure/apply-pending-measure-updates';

export const analysisKeys = {
  zoning: (analysisId: number) =>
    queryOptions({
      queryKey: ['zoning', analysisId],
      queryFn: () => zoningApi.getZoning(analysisId as number),
    }),
  measures: (analysisId: number) =>
    queryOptions({
      queryKey: ['measures', analysisId],
      queryFn: async ({ client }) => {
        const measures = await zoningApi.getMeasures(analysisId);
        // Keep HL / paused updateMeasure values when a refetch wins the race.
        return applyPendingMeasureUpdates(measures, client);
      },
    }),
  measureDetail: (measureId: number) =>
    queryOptions({
      queryKey: ['measures', 'detail', measureId],
      queryFn: () => zoningApi.getMeasure(measureId),
    }),
  points: (analysisId: number) => ['points', { analysisId }],
};
